<div class="centered">
  <button (click)="prepareAndShowKurzantragModal()" mat-flat-button color="primary">
    {{ 'new_antrag.button.start_with_kurzantrag' | translate }}
  </button>
</div>
